module.exports = __webpack_public_path__ + "img/Add-Image-Placeholder.f6caab35.svg";